import { lazy } from 'react';

const LazyMainMenu = lazy(() => import('shared/components/main-components/main-menu'));
export default LazyMainMenu;
